import { Grid } from '@mui/material';
import { GridComponent } from '@model/content';

export const GridItem = ({ xs, sm, md, lg, xl, children }: GridComponent) => {
  return (
    <Grid item xs={Number(xs)} sm={Number(sm)} md={Number(md)} lg={Number(lg)} xl={Number(xl)}>
      {children}
    </Grid>
  );
};
